const backToTop = (option) => {
	const section = document.querySelector(option);
	if (section) {
		section.scrollIntoView({ behavior: "smooth", block: "start" });
	}
};
export default backToTop;
